var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfCustod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.897,
    height: 37.344,
    viewBox: "0 0 36.897 37.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-222 -1845.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.726 1872.836l2.494-.775c1.662-.516 4.985.332 7.018.955a1.815 1.815 0 002.267-1.192h0a1.819 1.819 0 00-1.245-2.3l-6.454-1.8a9.305 9.305 0 00-8.134 1.553l-5.67 4.31v7.953l6.993-2.306 8.531.953a6.8 6.8 0 004.471-1.093l14.094-10.085a1.561 1.561 0 00.49-2.083h0a1.562 1.562 0 00-2.094-.594l-11.3 6.082",
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.259 1869.525l6.068-3.358a5.546 5.546 0 014.438-.41l1.72.573m-16.058 2.124l4.865-2.694a6.86 6.86 0 014.93-.668l1.583.381",
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.217 1855.516a2.092 2.092 0 00-.562-.636 3.152 3.152 0 00-.742-.408c-.251-.1-.508-.188-.766-.269l-.739-.237a3.124 3.124 0 01-.576-.248 1.071 1.071 0 01-.338-.29.557.557 0 01-.1-.345.369.369 0 01.067-.229.742.742 0 01.245-.208 1.594 1.594 0 01.407-.146 2.566 2.566 0 01.815-.034 7.5 7.5 0 01.8.124l.354.075a.724.724 0 00.765-.19.714.714 0 00.177-.471.735.735 0 00-.131-.419.72.72 0 00-.392-.29 4.775 4.775 0 00-.9-.223c-.165-.028-.542-.049-.542-.064v-.237a.6.6 0 00-.177-.507.924.924 0 00-1.01.005c-.145.119-.38.3-.38.5v.255c0 .034-.2.081-.373.145a2.218 2.218 0 00-.7.427 2.012 2.012 0 00-.519.674 1.885 1.885 0 00-.2.908 2.049 2.049 0 00.186.876 1.965 1.965 0 00.469.625 2.585 2.585 0 00.641.414 6.691 6.691 0 00.7.273q.348.115.714.226c.229.069.45.146.658.23a2.709 2.709 0 01.32.159 1.049 1.049 0 01.213.165.53.53 0 01.154.393.528.528 0 01-.08.3.814.814 0 01-.256.25 1.406 1.406 0 01-.418.174 3.326 3.326 0 01-1.071.041 3.391 3.391 0 01-.41-.062 3.886 3.886 0 01-.347-.089l-.367-.112a.695.695 0 00-.936.667.74.74 0 00.132.417.8.8 0 00.41.3 6.428 6.428 0 00.803.226 3.16 3.16 0 00.3.09c.049.007-.032.014-.032.02v.287c0 .269.3.424.4.507a.933.933 0 00.512.15.676.676 0 00.422-.15.621.621 0 00.229-.507v-.314c0-.037.464-.089.659-.158a3.046 3.046 0 00.864-.451 2.288 2.288 0 00.613-.708 2 2 0 00.237-.957 1.889 1.889 0 00-.202-.944z",
    fill: "#00cd99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.424,
    cy: 8.424,
    r: 8.424,
    transform: "translate(231.152 1846.193)",
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfCustod);
export default __webpack_public_path__ + "static/media/selfCustod.2afe4af3f6cca965479e4832d44736d7.svg";
export { ForwardRef as ReactComponent };